import { SupportedLocale } from '@src/cnst/translations.cnst'
import { NcLink } from '@src/components/nc-link/NcLink.component'
import { languageContext } from '@src/context/language.context'
import { ReactNode, useContext } from 'react'
import styles from './HeroBadges.module.scss'

export function HeroBadges(): ReactNode {
  const { locale } = useContext(languageContext)

  const starIconUrl = '/icons/star-rounded.svg'
  const fsabadgeUrl = '/icons/ab373/fsa-hsa.svg'

  const link = {
    [SupportedLocale.svSE]: '/sv/reviews',
    [SupportedLocale.enUS]: '/reviews',
    [SupportedLocale.ptBR]: '/pt-br/reviews',
    [SupportedLocale.esUS]: '/es/reviews',
    [SupportedLocale.enCA]: '/reviews',
  }

  return (
    <div className={styles.HeroBadges}>
      <NcLink className={styles.HeroBadge__appStore} to={link[locale]}>
        <div className={styles.HeroBadges__badge}>
          <span className={styles.HeroBadges__highlight}>
            4.8 <img className={styles.HeroBadges__icon} src={starIconUrl} alt="Star Icon" />
          </span>
          <p className={styles.HeroBadges__text}>57.7K+ global ratings</p>
        </div>
      </NcLink>

      <div className={styles.HeroBadges__badge}>
        <p className={styles.HeroBadges__container}>
          <span className={styles.HeroBadges__highlight}>#1</span>
          <span className={styles.HeroBadges__highlight}>FDA Cleared</span>
        </p>
        <p className={styles.HeroBadges__text}>Birth Control App</p>
      </div>

      <div className={styles.HeroBadges__badge}>
        <p className={styles.HeroBadges__container}>
          <img className={styles.HeroBadges__FSA} src={fsabadgeUrl} alt="FSA & HSA Icon" />
          <span className={styles.HeroBadges__highlight}>FSA & HSA</span>
        </p>
        <p className={styles.HeroBadges__textFSA}>Eligible</p>
      </div>
    </div>
  )
}
